import { render, staticRenderFns } from "./payment-gateway-braintree.vue?vue&type=template&id=018c2cec&scoped=true"
import script from "./payment-gateway-braintree.vue?vue&type=script&lang=ts"
export * from "./payment-gateway-braintree.vue?vue&type=script&lang=ts"
import style0 from "./payment-gateway-braintree.vue?vue&type=style&index=0&id=018c2cec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c2cec",
  null
  
)

export default component.exports